import api from 'app/api';
import getAll from './get-nested-product-categories';
import get from './get-nested-product-category';
import add from './add-nested-product-category';
import edit from './edit-nested-product-category';

export const nestedProductCategoriesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getNestedProductCategories: getAll(builder),
        getNestedProductCategory: get(builder),
        addNestedProductCategory: add(builder),
        editNestedProductCategory: edit(builder),
    }),
});

export const {
    useGetNestedProductCategoriesQuery,
    useGetNestedProductCategoryQuery,
    useAddNestedProductCategoryMutation,
    useEditNestedProductCategoryMutation,
} = nestedProductCategoriesApi;
